<template>
  <div v-show="isEnabled">
    <MetadataDrawerMain
      v-show="activeComponent === 'main'"
      @setActiveComponent="setActiveComponent"
    />
    <MetadataDrawerPlugin
      v-show="activeComponent === 'plugin'"
      @setActiveComponent="setActiveComponent"
    />
  </div>
</template>

<script>
import MetadataDrawerMain from './MetadataDrawerMain.vue';
import MetadataDrawerPlugin from './MetadataDrawerPlugin.vue';

export default {
  name: 'MetadataDrawerActive',
  components: {
    MetadataDrawerMain,
    MetadataDrawerPlugin,
  },
  data() {
    return {
      activeComponent: 'main',
      isEnabled: true,
    };
  },
  methods: {
    setActiveComponent(component) {
      this.activeComponent = component;
    },
    onPluginDisable() {
      this.isEnabled = false;
      this.activeComponent = 'main';
    },
    onPluginEnable() {
      this.isEnabled = true;
    },
  },
};
</script>
